import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSelectChange } from '@angular/material/select';
import { WarrantyFilterViewModel } from '../../interfaces/warranty-viewmodel.interface';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'app-warranty-filter-section',
  templateUrl: './warranty-filter-section.component.html',
  styleUrls: ['./warranty-filter-section.component.scss']
})
export class WarrantyFilterSectionComponent implements OnInit, OnDestroy{

  @Output() filters = new EventEmitter<WarrantyFilterViewModel>;
  public currentDate = new Date();
  public selectFilters: Array<any>;
  public filterForm: FormGroup;
  public searchSubscription: Subscription;

  constructor(private fb: FormBuilder){
    this.filterForm  = this.fb.group({
      dateRange: 1,
      start: null,
      end: null,
      search: ''
    });

   this.setSelectFilters(this.currentDate);
  }

  ngOnInit(): void {
      this.searchSubscription = this.filterForm.controls['search'].valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(() => {
        this.sendFilters();
      })
  }
  
  setSelectFilters(date: Date):void {
    const currentYear = date.getFullYear();
    this.selectFilters = [
      { value: 1, text: 'Hoy' },
      { value: 2, text: 'Ayer' },
      { value: 3, text: 'Esta semana' },
      { value: 4, text: 'Semana anterior' },
      { value: 5, text: 'Este mes' },
      { value: 6, text: 'Mes pasado' },
      { value: 0, text: 'Personalizado'}
    ];
  }

  public changeFilterSelect(change: MatSelectChange):void {
    const { value } = change;
    this.setDateRangeFromSelect(value);
    this.sendFilters();
  }

  changeDateInput(event: MatDatepickerInputEvent<Date>) {
    const {start, end } = this.filterForm.value;
    if(start && end){
      this.filterForm.patchValue({dateRange: 0});
      this.sendFilters();
    }
  }

  applyDateRangePicker() {
    this.filterForm.patchValue({
      dateRange: 0
    });
  }
  
  private setDateRangeFromSelect(selectVal: number) {
    let startDate: Date | null;
    let endDate: Date | null;

    switch(selectVal) {
      case 1:
        startDate = this.currentDate;
        endDate = this.currentDate;
        break;
      case 2:
        startDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate()-1);
        endDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate()-1);
        break;
      case 3:
        startDate = new Date(this.currentDate).firstDayOfWeek(1)
        endDate = new Date(this.currentDate).lastDayOfWeek(0);
        break;
      case 4:
        const prevWeek = new Date(this.currentDate);
        prevWeek.setDate(prevWeek.getDate() -7);
        startDate = new Date(prevWeek).firstDayOfWeek(1)
        endDate = new Date(prevWeek).lastDayOfWeek(0);
        break;
      case 5: 
        startDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
        endDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
        break;
      case 6:
        startDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() -1, 1);
        endDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 0);
        break;
      default:
        return;
    }
    this.filterForm.patchValue({
      start: startDate,
      end: endDate
    });
  }

  public sendFilters(): void {
    const {start, end, search} = this.filterForm.value;
    const filterViewModel: WarrantyFilterViewModel = {
      start: start,
      end: end,
      search: search
    };
    this.filters.emit(filterViewModel);
  }

  public ngOnDestroy(): void {
      this.searchSubscription.unsubscribe();
  }
}
